import React, { useRef } from "react";
import { Helmet } from "react-helmet";
import classnames from "classnames";
import { Link, withRouter } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import LanguageIcon from "@material-ui/icons/Language";
import SearchIcon from "@material-ui/icons/Search";
import { setLanguage, setSearch } from "../../actions/profileActions";
import { menu } from "../../constants";
import "./Navbar.css";

const useStyles = makeStyles((theme) => ({
  navbar: {
    backgroundColor: "rgb(229, 239, 241)",
    // filter: 'drop-shadow(2px 4px 12px rgb(200,200,200))'
  },
}));

const Navbar = ({
  location,
  setLanguage,
  setSearch,
  language,
  search,
  labels,
}) => {
  const classes = useStyles();

  const {
    setLangBtnTitle,
    languages,
    orgTitle2,
    searchPlaceholder,
    tmLabel,
    designLabel,
    originNameLabel,
  } = labels;
  const searchRef = useRef();

  const handleChange = (lang) => {
    setLanguage(lang);
  };

  const checkSearchKey = (str) => {
    if (!str.search(/[~'`/\\@#!$%^&*\[\]()~{}|?><,";:./+_-]/g)) {
      return false;
    } else {
      return true;
    }
  };

  return (
    <div className={classes.navbar}>
      <Helmet>
        {language == 0 && <title>부흥</title>}
        {language == 1 && <title>Buhung</title>}
        {language == 2 && <title>复兴</title>}
        {language == 3 && <title>восстановле́ние</title>}
      </Helmet>
      <div className="container w-100">
        <div className="d-flex justify-content-between align-items-center">
          {/* <div className="org-name"></div> */}

          <div className="d-flex flex-column justify-content-end h-100 flex-grow-1">
            <nav className="navbar navbar-expand-md navbar-light h-100">
              <a className="navbar-brand" href="#">
                <Link
                  className="top-mark mt-0 z1"
                  to="/"
                  style={{ top: "0px", padding: "5px 15px" }}
                >
                  <img
                    className="org-mark"
                    src="./assets/mark1.png"
                    alt="ipa_mark"
                    style={{ width: "110px", height: "110px" }}
                    onClick={() => {
                      searchRef.current.value = "";
                      setSearch("");
                    }}
                  />
                  <img
                    className="org-logo"
                    src="./assets/logo.png"
                    alt="ipa_mark"
                    style={{
                      width: "170px",
                      height: "110px",
                      marginLeft: "24px",
                    }}
                    onClick={() => {
                      searchRef.current.value = "";
                      setSearch("");
                    }}
                  />
                </Link>
              </a>
              <button
                className="navbar-toggler"
                type="button"
                data-toggle="collapse"
                data-target="#collapsibleNavbar"
              >
                <span className="navbar-toggler-icon"></span>
              </button>
              <div className="collapse navbar-collapse" id="collapsibleNavbar">
                <ul
                  className="navbar-nav ml-5 ml-sm-5 pl-sm-4 ml-md-auto mr-5 mr-sm-5 pr-sm-4 mr-md-auto pt-5"
                  // style={{
                  //   visibility: location.pathname == "/view" ? "hidden" : "",
                  // }}
                >
                  {menu.slice(0, 1).map((item, index) => {
                    return (
                      <li
                        key={index}
                        className="nav-item mx-sm-1 mx-md-2 mx-lg-4 text-center"
                      >
                        <Link
                          className={`h6 nav-link ${
                            location.pathname === item.url ? "active" : ""
                          }`}
                          to={item.url}
                          onClick={() => {
                            searchRef.current.value = "";
                            setSearch("");
                          }}
                        >
                          {item.title[language]}
                        </Link>
                      </li>
                    );
                  })}
                  <li className="nav-item mx-sm-1 mx-md-2 mx-lg-4 text-center">
                    <Link
                      className={`h6 nav-link ${
                        location.pathname === "/trademark" ? "active" : ""
                      }`}
                      to="/trademark"
                      onClick={() => {
                        searchRef.current.value = "";
                        setSearch("");
                      }}
                    >
                      {tmLabel[language]}
                    </Link>
                  </li>
                  <li className="nav-item mx-sm-1 mx-md-2 mx-lg-4 text-center">
                    <Link
                      className={`h6 nav-link ${
                        location.pathname === "/design" ? "active" : ""
                      }`}
                      to="/design"
                      onClick={() => {
                        searchRef.current.value = "";
                        setSearch("");
                      }}
                    >
                      {designLabel[language]}
                    </Link>
                  </li>
                  <li className="nav-item mx-sm-1 mx-md-2 mx-lg-4 text-center">
                    <Link
                      className={`h6 nav-link ${
                        location.pathname === "/originname" ? "active" : ""
                      }`}
                      to="/originname"
                      onClick={() => {
                        searchRef.current.value = "";
                        setSearch("");
                      }}
                    >
                      {originNameLabel[language]}
                    </Link>
                  </li>
                </ul>
                <div className="d-flex flex-column justify-content-between h-100">
                  <div className="d-flex flex-row-reverse dropdown">
                    <button
                      type="button"
                      className="btn dropdown-toggle btn-sm d-flex align-items-center h12 color-white"
                      data-toggle="dropdown"
                      style={{
                        borderRadius: "20px",
                        backgroundColor: "rgb(41,194,225)",
                      }}
                    >
                      <LanguageIcon></LanguageIcon>
                      &nbsp;&nbsp;&nbsp;{setLangBtnTitle[language]}&nbsp;&nbsp;
                    </button>
                    <div className="dropdown-menu z2">
                      {languages.map((item, index) => (
                        <a
                          key={index}
                          className="dropdown-item"
                          href="#"
                          onClick={() => {
                            searchRef.current.value = "";
                            setSearch("");
                            handleChange(index);
                          }}
                        >
                          {item}
                        </a>
                      ))}
                    </div>
                  </div>
                  {/* {location.pathname === "/" ||
                  location.pathname === "/trademark" ||
                  location.pathname === "/design" ? ( */}
                  <div className="input-group input-group-md pt-3">
                    <div className="input-group-prepend d-md-none d-md-none">
                      <span className="input-group-text">
                        <SearchIcon />
                      </span>
                    </div>
                    <input
                      type="text"
                      className="form-control search"
                      placeholder={searchPlaceholder[language]}
                      defaultValue={search}
                      // value={search}
                      ref={searchRef}
                      style={{
                        visibility:
                          location.pathname == "/view" ? "hidden" : "",
                      }}
                      // disabled={location.pathname == "/originname"}
                      onKeyDown={(event) => {
                        if (
                          (event.code === "NumpadEnter" ||
                            event.code === "Enter" ||
                            event.keyCode == 13) &&
                          checkSearchKey(event.target.value)
                        ) {
                          setSearch(event.target.value);
                        } else if (
                          (event.code === "NumpadEnter" ||
                            event.code === "Enter" ||
                            event.keyCode == 13) &&
                          !checkSearchKey(event.target.value)
                        ) {
                          if (language == 0) {
                            alert("특수문자검색을 진행할수 없습니다");
                          } else if (language == 1) {
                            alert("Do not enter special character");
                          } else if (language == 2) {
                            alert("Do not enter special character");
                          } else if (language == 3) {
                            alert("로어 character");
                          }
                        }
                      }}
                      // onBlur={(event) => {
                      //   setSearch(event.target.value);
                      // }}
                      onChange={(event) => {
                        if (event.target.value.length >= 20) {
                          searchRef.current.value = event.target.value.slice(
                            0,
                            20
                          );
                        }
                      }}
                    />
                  </div>
                  {/* ) : (
                    <></>
                  )} */}
                </div>
              </div>
            </nav>
          </div>
          {/* <div className="d-flex flex-column justify-content-between h-100 p-3">
            <div className="d-flex flex-row-reverse dropdown">
              <button
                type="button"
                className="btn dropdown-toggle btn-sm d-flex align-items-center h12 color-white"
                data-toggle="dropdown"
                style={{
                  borderRadius: "20px",
                  backgroundColor: "rgb(41,194,225)",
                }}
              >
                <LanguageIcon></LanguageIcon>
                &nbsp;&nbsp;&nbsp;{setLangBtnTitle[language]}&nbsp;&nbsp;
              </button>
              <div className="dropdown-menu z2">
                {languages.map((item, index) => (
                  <a
                    key={index}
                    className="dropdown-item"
                    href="#"
                    onClick={() => {
                      searchRef.current.value = "";
                      setSearch("");
                      handleChange(index);
                    }}
                  >
                    {item}
                  </a>
                ))}
              </div>
            </div>
            {location.pathname === "/" ||
            location.pathname === "/trademark" ||
            location.pathname === "/design" ? (
              <div className="">
                <div className="input-group input-group-sm">
                  <div className="input-group-prepend d-sm-none d-md-none">
                    <span className="input-group-text">
                      <SearchIcon />
                    </span>
                  </div>
                  <input
                    type="text"
                    className="form-control search"
                    placeholder={searchPlaceholder[language]}
                    defaultValue={search}
                    // value={search}
                    ref={searchRef}
                    onKeyDown={(event) => {
                      if (
                        event.code === "Enter" &&
                        checkSearchKey(event.target.value)
                      ) {
                        setSearch(event.target.value);
                      } else if (
                        event.code === "Enter" &&
                        !checkSearchKey(event.target.value)
                      ) {
                        if (language == 0) {
                          alert("특수문자검색을 진행할수 없습니다");
                        } else if (language == 1) {
                          alert("Do not enter special character");
                        } else if (language == 2) {
                          alert("Do not enter special character");
                        } else if (language == 3) {
                          alert("로어 character");
                        }
                      }
                    }}
                    // onBlur={(event) => {
                    //   setSearch(event.target.value);
                    // }}
                    onChange={(event) => {
                      if (event.target.value.length >= 20) {
                        searchRef.current.value = event.target.value.slice(
                          0,
                          20
                        );
                      }
                    }}
                  />
                </div>
              </div>
            ) : (
              <></>
            )}
          </div> */}
          {/* <div className="org-name">{orgTitle2[language]}</div> */}
        </div>
      </div>
      {/* <div
        className={classnames(
          "w-100"
          // location.pathname === "/" ? "bg-white" : ""
        )}
        style={{ height: "72px" }}
      >
        <div className="navbar navbar-expand navbar-expand-sm h-100">
          <div className="container position-relative"></div>
        </div>
      </div> */}
    </div>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  language: state.profile.language,
  search: state.profile.search,
  labels: state.labels,
});

export default connect(mapStateToProps, { setLanguage, setSearch })(
  withRouter(Navbar)
);
